import gql from 'graphql-tag';

export const GET_AFTERMARKET_PRODUCTS = gql`
  query GetAftermarketProducts($accountId: ID!) {
    aftermarketProducts(accountId: $accountId) {
      aftermarketProductId
      accountIdCreatedBy
      productName
      partnerLinks {
        name
        partnerLinkId
      }
      aftermarketVendorApiChannel
      productCategory
      productType
      criteria
      productDescriptionExternal
      productDescriptionInternal
      createdDateTime
      productLogoUrl
      addons {
        aftermarketProductId
        productName
      }
      externalId
      aftermarketProductCatalogDetails {
        productSummary
        limitationsOfLiability
        eligibilityAndInclusions
        legalDisclaimer
        paragraphDescription
        coverageDetails
      }
    }
  }
`;
